import { IS_PRODUCTION } from '@dtx-company/true-common/src/constants/env'
import { LEATHERWOOD_API_ENDPOINT } from '@dtx-company/true-common/src/constants/endpoints'
import { getHostFromUrl } from '@app/common/src/utils/utils'
import { stringify } from 'query-string'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'

const getDashboardURL = LEATHERWOOD_API_ENDPOINT + '/looker/dashboard'

interface GetEmbedUrlResponse {
  url: string
}

const getLookerEmbedUrl = async (
  token: string,
  viewType: 'dashboard' | 'look',
  ithacaIdOverride?: string,
  dashboardSlug?: string
): Promise<string> => {
  const params = {
    embed_domain: encodeURIComponent(getHostFromUrl(window.location.href) ?? ''),
    viewType
  } as Record<string, string>

  if (ithacaIdOverride) {
    params.ithaca_id = ithacaIdOverride
  }

  const response = await fetch(`${getDashboardURL}/${dashboardSlug}?${stringify(params)}`, {
    method: 'GET',
    headers: { Authorization: 'Bearer ' + token }
  })
  return ((await response.json()) as GetEmbedUrlResponse).url
}

interface ReportPageParams {
  ithaca_id?: string
  dashboard_slug?: string
}

export const useLookerEmbedURL = (): {
  isLoading: boolean
  error: boolean
  embedUrl: string | null
} => {
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(false)
  const [embedUrl, setEmbedUrl] = useState<string | null>(null)
  const { token, jwt } = useAuthState()
  const { query } = useRouter()
  const { ithaca_id: ithacaIdOverride, dashboard_slug }: ReportPageParams = query
  const ithacaId = (!IS_PRODUCTION && ithacaIdOverride) || jwt?.ithacaId

  useEffect(() => {
    if (token && dashboard_slug) {
      const viewType = dashboard_slug === 'raw-data-report' ? 'look' : 'dashboard'
      getLookerEmbedUrl(token, viewType, ithacaId, dashboard_slug)
        .then(url => {
          if (!url) return setError(true)
          setEmbedUrl(url)
        })
        .catch(err => console.error(err))
        .finally(() => setIsLoading(false))
    }
  }, [token, dashboard_slug, jwt, ithacaId])

  return { isLoading, error, embedUrl }
}
